import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x7501,
  properties: ["read", "write", "notify"],
};

export function generateMockHDCNotifyData(): DomianControl.HDCNotifyData {
  const data = getMockDataByKeys([
    "UIRx_HDCAvlbl",
    "UIRx_HDCDispVxTar",
    "UIRx_HDCCtrlA",
    "UIRx_VAFBrkFxTrgt",
    "UIRx_DrvrReqTrgtFxBrk_Bch1",
    "UIRx_VehSpd",
  ]);
  return data;
}
